/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============ LANDING & CATNAV JAVASCRIPT ============= */
/* ===================== Essence ======================== */
/* ====================================================== */
/* ====================================================== */

// handleize function
const handleize = (str) => {
  return str.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase();
};

// Create the useroptions object if it does not already exist
if (!window.klevu_uc_userOptions) window.klevu_uc_userOptions = {};

// set the landingFilterPosition
window.klevu_uc_userOptions.landingFilterPosition = 'left';

klevu.modifyResponse("landing,catnav", function(data, scope){

  /* loop through filters in the response */

  klevu.each(data.template.query.productList.filters, function(indx, filter)  {
    if (filter.key === 'bed_style') {
      const metaobjectsData = JSON.parse(sessionStorage.getItem('metaobjectsData'));
       filter.options = filter.options.map((option) => {
        const metaobject = metaobjectsData.find((metaobject) => metaobject.id === option.value);
        return {
          image: metaobject.image,
          label: metaobject.label,
          name: option.name,
          value: option.value,
          count: option.count,
          selected: option.selected,
        };
      });
    }
    filter.collectionHandle = collectionHandleKlevu;
  });
});

klevu({
  theme: {
    setHelpers: {
      all: {
        namePrettifier: function (name) {
          return name.replace(/[\[\]"]/g, '');
        },
        myCustomSortBy: function(dataLocal) {
          /* sets the selected option to the display */

          var selectedText = "";

          var klevuStorage = klevu.getSetting(klevu.settings, "settings.storage");

          var klevu_lang = window.klevuSettings.url.landing.indexOf('fr') !== -1 ? 'fr' : 'en';

          if (klevu_lang == 'fr') {
            switch (klevuStorage.sort.getElement(dataLocal) == dataLocal ? "RELEVANCE" : klevuStorage.sort.getElement(dataLocal)) {
              case "RELEVANCE":
                  selectedText = "Pertinence";
                  break;
              case "PRICE_ASC":
                  selectedText = "Prix, faible à élevé";
                  break;
              case "PRICE_DESC":
                  selectedText = "Prix, élevé à faible";
                  break;
              default:
                  selectedText = "Pertinence";
            }
          } else {
            switch (klevuStorage.sort.getElement(dataLocal) == dataLocal ? "RELEVANCE" : klevuStorage.sort.getElement(dataLocal)) {
              case "RELEVANCE":
                  selectedText = "Relevance";
                  break;
              case "PRICE_ASC":
                  selectedText = "Price, Low to high";
                  break;
              case "PRICE_DESC":
                  selectedText = "Price, High to low";
                  break;
              default:
                  selectedText = "Relevance";
            }
          }
          return selectedText;
        }
      }
    },
  },
});

var klevu_custom_translations = {
  "en": {
    "<b>%s</b> assemblyFiles": "<b>%s</b> Assembly Files",
    "Starting at": "Starting at",
    "Filters": "Filters",
    "No records found for your selection": "No records found for your selection",
    "Search Results": "Search Results",
    "Search text": "Search text",
    "Clear Filters": "Clear Filters",
    "Clear": "Clear",
    "Apply": "Apply",
    "found": "found",
    "for": "for",
    "Assembly Files": "Assembly Files",
    "found for": "found for",
    "Relevance": "Relevance",
    "Price, low to high": "Price, low to high",
    "Price, high to low": "Price, high to low",
    "Product": "Product",
    "Lifestyle": "Lifestyle",
    "Livingroom_Filter": "Living room",
    "Bedroom_Filter": "Bedroom",
    "Bed Size": "Bed Size",
    "Size": "Size",
    "Configuration": "Configuration",
    "Color_Filter": "Color",
    "Collection": "Collection",
    "Depth": "Depth",
    "Height": "Height",
    "Width": "Width",
    "Shelf Style": "Shelf Style",
    "Result": "Result",
    "Results": "Results",
    "Living Room": "Living Room",
    "Bedroom": "Bedroom",
    "Media Storage": "Media Storage",
    "TV Stands": "TV Stands",
    "TV Wall Panels": "TV Wall Panels",
    "Wall Panel Options": "Wall Panel Options",
    "Murphy Beds": "Murphy Beds",
    "Cabinet Beds": "Cabinet Beds",
    "Coordinating Items": "Coordinating Items",
    "Queen": "Queen",
    "Full": "Full",
    "Vertical Murphy Bed": "Vertical Murphy Bed",
    "Murphy Bed with Storage": "Murphy Bed with Storage",
    "Desks with Hutch": "Desks with Hutch",
    "View Details": "View Details",
    "Pur": "Pur",
    "Florence": "Florence",
    "Barletta": "Barletta",
    "Key West": "Key West",
    "Connexion": "Connexion",
    "Nebula": "Nebula",
    "Versatile": "Versatile",
    "Pro-Biz Office": "Pro-Biz Office",
    "Pro-Linea": "Pro-Linea",
    "Borealis": "Borealis",
    "Edge": "Edge",
    "Norma": "Norma",
    "Upstand": "Upstand",
    "Viva": "Viva",
    "Proconcept Plus": "Proconcept Plus",
    "Avalon": "Avalon",
    "I3 Plus": "I3 Plus",
    "Orion": "Orion",
    "Embassy": "Embassy",
    "Logan": "Logan",
    "Lumina": "Lumina",
    "Pro-Vega": "Pro-Vega",
    "Ridgeley": "Ridgeley",
    "Carina": "Carina",
    "Prestige Plus": "Prestige Plus",
    "Solay": "Solay",
    "Universel": "Universel",
    "Cielo": "Cielo",
    "Dayton": "Dayton",
    "Equinox": "Equinox",
    "Innova": "Innova",
    "Office Desks": "Office Desks",
    "Sofa Murphy Bed": "Sofa Murphy Bed",
    "Executive Desks": "Executive Desks",
    "Standing Desks": "Standing Desks",
    "Home Entertainment": "Home Entertainment",
    "Murphy Bed with Desk": "Murphy Bed with Desk",
    "Walk-In": "Walk-In",
    "Reach-In": "Reach-In",
    "Wardrobe": "Wardrobe",
    "Horizontal Murphy Bed": "Horizontal Murphy Bed",
    "Office Cubicles": "Office Cubicles",
    "Table Desks": "Table Desks",
    "L-Shaped Desks": "L-Shaped Desks",
    "Straight": "Straight",
    "U-Shaped Desks": "U-Shaped Desks",
    "L-Shaped": "L-Shaped",
    "U-Shaped": "U-Shaped",
    "Antigua": "Antigua",
    "Antigua & Black": "Antigua & Black",
    "Antigua & White": "Antigua & White",
    "Bark Gray": "Bark Gray",
    "Bark Gray & Slate": "Bark Gray & Slate",
    "Bark Gray & White": "Bark Gray & White",
    "Black": "Black",
    "Black & Bark Gray": "Black & Bark Gray",
    "Black & White": "Black & White",
    "Black Walnut": "Black Walnut",
    "Brown": "Brown",
    "Charcoal": "Charcoal",
    "Dark Chocolate": "Dark Chocolate",
    "Deep Gray": "Deep Gray",
    "Deep Gray & Black": "Deep Gray & Black",
    "Deep Gray & White": "Deep Gray & White",
    "Fresh Walnut": "Fresh Walnut",
    "Gray": "Gray",
    "High Gloss Black": "High Gloss Black",
    "High Gloss Black/Urban Stone": "High Gloss Black/Urban Stone",
    "High Gloss White": "High Gloss White",
    "High Gloss White/Fresh Walnut": "High Gloss White/Fresh Walnut",
    "Linen White Oak": "Linen White Oak",
    "Natural": "Natural",
    "Platinum Gray": "Platinum Gray",
    "Pure White Oak": "Pure White Oak",
    "Rustic Brown": "Rustic Brown",
    "Rustic Brown & White": "Rustic Brown & White",
    "Slate & Sandstone": "Slate & Sandstone",
    "Tan": "Tan",
    "Urban Stone": "Urban Stone",
    "Walnut Gray": "Walnut Gray",
    "Walnut Gray & White": "Walnut Gray & White",
    "White": "White",
    "White & Black": "White & Black",
    "White & Deep Gray": "White & Deep Gray",
    "White & Platinum Gray": "White & Platinum Gray",
    "White Chocolate": "White Chocolate",
    "White Chocolate & Antigua": "White Chocolate & Antigua",
  },
  "fr": {
    "<b>%s</b> assemblyFiles": "<b>%s</b> Instructions d'assemblage",
    "Starting at": "Débutant à",
    "Filters": "Filtres",
    "No records found for your selection": "Aucun enregistrement trouvé pour votre sélection",
    "Search Results": "Résultats de la recherche",
    "Search text": "Texte de recherche",
    "Clear Filters": "Effacer les filtres",
    "Clear": "Effacer",
    "Apply": "Appliquer",
    "found": "trouvé",
    "for": "pour",
    "Assembly Files": "Instructions d'assemblage",
    "found for": "trouvé pour",
    "Relevance": "Pertinence",
    "Price, low to high": "Prix, faible à élevé",
    "Price, high to low": "Prix, élevé à faible",
    "Product": "Produit",
    "Lifestyle": "Mode de vie",
    "Livingroom_Filter": "Salon",
    "Bedroom_Filter": "Chambre à coucher",
    "Bed Size": "Taille du lit",
    "Size": "Taille",
    "Configuration": "Configuration",
    "Color_Filter": "Couleur",
    "Collection": "Collection",
    "Depth": "Profondeur",
    "Height": "Hauteur",
    "Width": "Largeur",
    "Shelf Style": "Style d'étagère",
    "Result": "Résultat",
    "Results": "Résultats",
    "Living Room": "Salon",
    "Bedroom": "Chambre à coucher",
    "Media Storage": "Rangement multimédia",
    "TV Stands": "Meubles télé",
    "TV Wall Panels": "Panneaux muraux",
    "Wall Panel Options": "Choix de panneau",
    "Murphy Beds": "Lits escamotables",
    "Cabinet Beds": "Lits armoires",
    "Coordinating Items": "Articles assortis",
    "Queen": "Grand lit",
    "Full": "Lit double",
    "Vertical Murphy Bed": "Lit escamotable vertical",
    "Murphy Bed with Storage": "Lit escamotable avec rangement",
    "Desks with Hutch": "Bureau avec huche",
    "View Details": "Afficher les détails",
    "Pur": "Pur",
    "Florence": "Florence",
    "Barletta": "Barletta",
    "Key West": "Key West",
    "Connexion": "Connexion",
    "Nebula": "Nebula",
    "Versatile": "Versatile",
    "Pro-Biz Office": "Pro-Biz Office",
    "Pro-Linea": "Pro-Linea",
    "Borealis": "Borealis",
    "Edge": "Edge",
    "Norma": "Norma",
    "Upstand": "Upstand",
    "Viva": "Viva",
    "Proconcept Plus": "Proconcept Plus",
    "Avalon": "Avalon",
    "I3 Plus": "I3 Plus",
    "Orion": "Orion",
    "Embassy": "Embassy",
    "Logan": "Logan",
    "Lumina": "Lumina",
    "Pro-Vega": "Pro-Vega",
    "Ridgeley": "Ridgeley",
    "Carina": "Carina",
    "Prestige Plus": "Prestige Plus",
    "Solay": "Solay",
    "Universel": "Universel",
    "Cielo": "Cielo",
    "Dayton": "Dayton",
    "Equinox": "Equinox",
    "Innova": "Innova",
    "Office Desks": "Bureaux professionnels",
    "Sofa Murphy Bed": "Canapé-lit escamotable",
    "Executive Desks": "Bureaux de direction",
    "Standing Desks": "Bureaux assis-debout",
    "Home Entertainment": "Divertissement à domicile",
    "Murphy Bed with Desk": "Lit escamotable avec bureau",
    "Walk-In": "Pièce-penderie",
    "Reach-In": "Petite garde-robe",
    "Wardrobe": "Grand garde-robe",
    "Horizontal Murphy Bed": "Lit escamotable horizontal",
    "Office Cubicles": "Postes de travail",
    "Table Desks": "Tables de travail",
    "L-Shaped Desks": "Bureaux en L",
    "Straight": "Systèmes droit",
    "U-Shaped Desks": "Bureaux en U",
    "L-Shaped": "Systèmes en L",
    "U-Shaped": "Systèmes en U",
    "Antigua": "Antigua",
    "Antigua & Black": "Antigua et noir",
    "Antigua & White": "Antigua et blanc",
    "Bark Gray": "Gris écorce",
    "Bark Gray & Slate": "Gris écorce et ardoise",
    "Bark Gray & White": "Gris écorce et blanc",
    "Black": "Noir",
    "Black & Bark Gray": "Noir et gris écorce",
    "Black & White": "Noir et blanc",
    "Black Walnut": "Noyer noir",
    "Brown": "Brun",
    "Charcoal": "Charbon",
    "Dark Chocolate": "Chocolat noir",
    "Deep Gray": "Gris profond",
    "Deep Gray & Black": "Gris profond et noir",
    "Deep Gray & White": "Gris profond et blanc",
    "Fresh Walnut": "Noyer frais",
    "Gray": "Gris",
    "High Gloss Black": "Noir lustré",
    "High Gloss Black/Urban Stone": "Noir lustré/pierre urbaine",
    "High Gloss White": "Blanc lustré",
    "High Gloss White/Fresh Walnut": "Blanc lustré/noyer frais",
    "Linen White Oak": "Chêne blanc lin",
    "Natural": "Naturel",
    "Platinum Gray": "Gris platine",
    "Pure White Oak": "Chêne blanc pur",
    "Rustic Brown": "Brun rustique",
    "Rustic Brown & White": "Brun rustique et blanc",
    "Slate & Sandstone": "Ardoise et grès",
    "Tan": "Beige",
    "Urban Stone": "Pierre urbaine",
    "Walnut Gray": "Gris boisé",
    "Walnut Gray & White": "Gris boisé et blanc",
    "White": "Blanc",
    "White & Black": "Blanc et noir",
    "White & Deep Gray": "Blanc et gris profond",
    "White & Platinum Gray": "Blanc et gris platine",
    "White Chocolate": "Chocolat blanc",
    "White Chocolate & Antigua": "Chocolat blanc et antigua",
  }
};

var klevu_lang = window.klevuSettings.url.landing.indexOf('fr') !== -1 ? 'fr' : 'en';

var klevu_storeTranslations = klevu_custom_translations[klevu_lang];


klevu.beforeActivation('catnav,landing', function (data, scope) {
  scope.kScope.template.setTemplate(
    klevuLandingTemplateProductBlockCustom2,
    'productBlock',
    true
  );
  scope.kScope.template.setTemplate(
    landingPageProductAddToCartCustom,
    'landingPageProductAddToCart',
    true
  );
  scope.kScope.template.setTemplate(
    KlevuLandingTemplateResultsCustom,
    'results',
    true
  );
  scope.kScope.template.setTemplate(
    klevuLandingTemplateSearchBarCustom,
    'klevuLandingTemplateSearchBar',
    true
  );
  scope.kScope.template.setTemplate(
    klevuLandingTemplatePaginationCustom,
    'pagination',
    true
  );
  scope.kScope.template.setTemplate(
    klevuLandingTemplateFiltersCustom,
    'filters',
    true
  );
  scope.kScope.template.setTemplate(
    klevuLandingTemplateSortByCustom,
    'sortBy',
    true
  );
  scope.kScope.template.setTemplate(
    klevuLandingTemplateBaseCustom,
    'klevuTemplateLanding',
    true
  );
  scope.kScope.template.setTemplate(
    klevuLandingTemplateResultsHeadingTitleCustom,
    'klevuLandingTemplateResultsHeadingTitle',
    true
  );

  // Remove scrollToTop
  scope.kScope.chains.events.keyUp.remove({
    name: 'scrollToTop',
  });

  (function (klevu) {
    klevu.extend(true, klevu.search.modules, {
      addParamsToURL: {
        base: {
          addURLtoHistory: function (data, scope, queryId) {
            // Global stuff
            if (
              typeof window.history === 'undefined' ||
              typeof window.history.pushState === 'undefined'
            ) {
              console.error(
                'This browser does not have the support of window.history or window.history.pushState'
              );
              return;
            }

            var searchPath = new URLSearchParams(window.location.search);
            var currentSearchPath;
            var previousSearchPath = searchPath.toString();

            // this is in case we're running our code where we dont have context.activeQueryId
            var activeQueryId = klevu.getObjectPath(
              data,
              'context.activeQueryId'
            );
            if (queryId && queryId.length) {
              activeQueryId = queryId;
            }

            // Check if there any filter selected
            let applyFilters =
              typeof data.localOverrides.query[activeQueryId].filters !==
              'undefined'
                ? data.localOverrides.query[activeQueryId].filters.applyFilters
                : {};
            let isThereFiltersSelected = false;
            // Check if applyFilters is an object (but not an array), and not empty
            if (
              typeof applyFilters === 'object' &&
              !Array.isArray(applyFilters) &&
              applyFilters !== null &&
              Object.keys(applyFilters).length > 0
            ) {
              isThereFiltersSelected = true;
            }

            // PAGINATION TO URL
            var hasPaginationEnabled = klevu.getSetting(
              klevu,
              'settings.theme.modules.pagination.searchResultsPage.enable'
            );
            var paginationQueryParam = 'Page';
            var currentPage = 0;

            if (hasPaginationEnabled) {
              var activeQueryMeta = klevu.getObjectPath(
                data,
                'template.query.' + activeQueryId + '.meta'
              );
              if (activeQueryMeta) {
                var productListLimit = activeQueryMeta.noOfResults;
                currentPage =
                  Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
              }

              if (currentPage === 0 || currentPage === 1) {
                searchPath.delete(paginationQueryParam);
              } else {
                searchPath.set(paginationQueryParam, currentPage);
              }

              currentSearchPath = searchPath.toString();
            }

            // FILTERS TO URL
            var activeQueryFilters = klevu.getObjectPath(
              data,
              'template.query.' + activeQueryId + '.filters'
            );
            var filterValuesQueryParam = '';

            if (activeQueryFilters) {
              klevu.each(activeQueryFilters, function (key, filter) {
                var selectedFilterKeyString = '';
                var filterOptions = filter.options;
                var selectedValues = '';

                if (filterOptions && filterOptions.length) {
                  klevu.each(filterOptions, function (key, option) {
                    if (option.selected === true) {
                      if (selectedValues.length) {
                        selectedValues += ',';
                      }
                      selectedValues += option.value;
                    }
                  });
                } else if (filter.type === 'SLIDER') {
                  var startValue = filter.start;
                  var endValue = filter.end;
                  var minValue = filter.min;
                  var maxValue = filter.max;
                  if (
                    typeof startValue !== 'undefined' &&
                    startValue !== null &&
                    typeof endValue !== 'undefined' &&
                    endValue !== null
                  ) {
                    if (
                      Number(startValue) === Number(minValue) &&
                      Number(endValue) === Number(maxValue)
                    ) {
                      // just skipping
                    } else {
                      selectedValues = startValue + '-' + endValue;
                    }
                  }
                }

                if (selectedValues.length) {
                  // selectedFilterKeyString += filter.key + ":" + selectedValues;
                  selectedFilterKeyString +=
                    encodeURIComponent(filter.key) +
                    ':' +
                    encodeURIComponent(selectedValues);
                }

                if (selectedFilterKeyString.length) {
                  if (filterValuesQueryParam.length) {
                    filterValuesQueryParam += ';';
                  }
                  filterValuesQueryParam += selectedFilterKeyString;
                }
              });
            }

            if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
              searchPath.set('Filters', filterValuesQueryParam);
            } else {
              searchPath.delete('Filters');
            }

            currentSearchPath = searchPath.toString();

            // ==============================
            // Final URL change
            if (previousSearchPath !== currentSearchPath) {
              var historyState = {
                page: currentPage,
                filters: currentSearchPath,
              };
              window.history.pushState(
                historyState,
                null,
                currentSearchPath
                  ? '?' + currentSearchPath
                  : window.location.pathname
              );
            }
          },

          restoreSearchParamsOnPageLoad: function (data, scope) {
            var hasAlreadyTriggered = klevu.getObjectPath(
              scope.kScope,
              'element.kScope.getAndUpdateFiltersTriggered'
            );
            if (hasAlreadyTriggered) return;

            var activeQueryId =
              klevu.getObjectPath(data, 'context.activeQueryId') ||
              'productList';

            var filtersFromURL =
              klevu.dom.helpers.getQueryStringValue('Filters');
            var paginationFromURL =
              klevu.dom.helpers.getQueryStringValue('Page');

            var matchedQueryParamId = '';
            var matchedQueryParamValue = '';
            var recordQueries = klevu.getObjectPath(
              data,
              'request.current.recordQueries'
            );

            if (recordQueries && recordQueries.length) {
              klevu.each(recordQueries, function (key, recordQuery) {
                if (recordQuery.id) {
                  if (
                    (paginationFromURL && paginationFromURL.length) ||
                    (filtersFromURL && filtersFromURL.length)
                  ) {
                    matchedQueryParamId = recordQuery.id;
                    matchedQueryParamValue =
                      paginationFromURL || filtersFromURL;
                  }
                }
              });
            }

            klevu.setObjectPath(
              scope.kScope,
              'element.kScope.getAndUpdateFiltersTriggered',
              true
            );

            matchedQueryParamId = activeQueryId || 'productList';

            if (matchedQueryParamId.length && matchedQueryParamValue.length) {
              activeQueryId = matchedQueryParamId;
              var storage = klevu.getSetting(
                scope.kScope.settings,
                'settings.storage'
              );
              if (storage.tabs) {
                storage.tabs.setStorage('local');
                storage.tabs.mergeFromGlobal();
                storage.tabs.addElement('active', activeQueryId);
                storage.tabs.mergeToGlobal();
              }
            }

            if (paginationFromURL && paginationFromURL > 1) {
              if (recordQueries && recordQueries.length) {
                klevu.each(recordQueries, function (key, recordQuery) {
                  if (recordQuery.id === activeQueryId) {
                    var limit = klevu.getObjectPath(
                      recordQuery,
                      'settings.limit'
                    );
                    limit = Number(limit);
                    if (limit > 0) {
                      var expectedOffset = (paginationFromURL - 1) * limit;
                      klevu.setObjectPath(
                        data,
                        'localOverrides.query.' +
                          activeQueryId +
                          '.settings.offset',
                        expectedOffset
                      );
                    }
                  }
                });
              }
            }

            // FILTERS
            if (filtersFromURL && filtersFromURL.length) {
              var facets = filtersFromURL.split(';');
              if (facets) {
                klevu.each(facets, function (key, facet) {
                  var splitFacet = facet.split(':');
                  if (splitFacet.length) {
                    var facetKey = decodeURIComponent(splitFacet[0]);
                    var facetValues = decodeURIComponent(splitFacet[1]).split(
                      ','
                    );
                    var applyFilters = klevu.getObjectPath(
                      data,
                      'localOverrides.query.' +
                        activeQueryId +
                        '.filters.applyFilters.filters'
                    );

                    if (applyFilters && applyFilters.length) {
                      // if there're some filters
                      var isExistingKey = false;
                      klevu.each(applyFilters, function (key, applyFilter) {
                        if (applyFilter.key === facetKey) {
                          isExistingKey = true;
                          klevu.each(facetValues, function (key, facetValue) {
                            var isFilterOptionMatched = false;
                            klevu.each(
                              applyFilter.values,
                              function (key, value) {
                                if (facetValue === value) {
                                  isFilterOptionMatched = true;
                                }
                              }
                            );
                            if (!isFilterOptionMatched) {
                              applyFilter.values.push(facetValue);
                            }
                          });
                        }
                      });
                      if (!isExistingKey) {
                        applyFilters.push({
                          key: facetKey,
                          values: facetValues,
                        });
                      }
                    } else {
                      klevu.setObjectPath(
                        data,
                        'localOverrides.query.' +
                          activeQueryId +
                          '.filters.applyFilters.filters',
                        [{ key: facetKey, values: facetValues }]
                      );
                    }
                  }
                });
              }
            }
          },

          updatePayloadOnPopState: function (data, scope, activeQueryId) {
            // SET PAGINATION PAYLOAD
            var paginationFromURL =
              klevu.dom.helpers.getQueryStringValue('Page');
            paginationFromURL = Number(paginationFromURL);
            var limit =
              window.klevuCurrentScope.element.kObject.getScope().data.request
                .original.queryRequest[0].settings.limit;
            limit = Number(limit);
            if (limit > 0) {
              var expectedOffset =
                (paginationFromURL - 1) * limit > 0
                  ? (paginationFromURL - 1) * limit
                  : 0;
              klevu.setObjectPath(
                data,
                'localOverrides.query.' + activeQueryId + '.settings.offset',
                expectedOffset
              );
              // klevu.search.modules.addParamsToURL.base.backBtnCounter.backBtn = 0;
            }

            // SET FILTER PAYLOAD
            var filtersFromURL =
              klevu.dom.helpers.getQueryStringValue('Filters');
            if (filtersFromURL && filtersFromURL.length) {
              var facets = filtersFromURL.split(';');
              // loop through all facets to get its values
              let facetKey = '';
              let facetValues = [];
              let facetsArray = [];

              klevu.each(facets, function (key, facet) {
                var splitFacet = facet.split(':');
                if (splitFacet.length) {
                  facetKey = decodeURIComponent(splitFacet[0]);
                  facetValues = decodeURIComponent(splitFacet[1]).split(',');
                  facetsArray.push({ key: facetKey, values: facetValues });
                }
              });
              // set the payload with correct filters:
              klevu.setObjectPath(
                data,
                'localOverrides.query.' +
                  activeQueryId +
                  '.filters.applyFilters.filters',
                facetsArray
              );
            } else {
              // reset filters if Back button pressed, and there's no filters
              klevu.setObjectPath(
                data,
                'localOverrides.query.' +
                  activeQueryId +
                  '.filters.applyFilters.filters',
                []
              );
            }
          },
        },
        build: true,
      },
      keepFacetsWithSelectedOptionsOpened: function () {
        const selectors = {
          kuFilterBox: '.kuFilterBox',
          kuSelected: '.kuSelected',
          kuFilterNames: '.kuFilterNames',
          kuFilterNamesCollapse: '.kuFilterNames.kuFilterCollapse',
          kuFilterHead: '.kuFilterHead',
          kuFilterHeadExpand: '.kuFilterHead.kuExpand',
          kuExpand: '.kuExpand',
          kuCollapse: '.kuCollapse',
          nouiElement: '.noUi-origin',
          priceFacetBlock: '[data-filter="klevu_price"]',
          kuFilterShowAll: '.kuFilterShowAll',
          kuFilterCollapse: '.kuFilterCollapse',
        };

        /** Collapse Filters by default */
        (function collapseAllFilters() {
          // Replace .kuFilterHead.kuCollapse with .kuFilterHead.kuExpand
          const kuFilterHeadElements = document.querySelectorAll(
            selectors.kuFilterHead
          );
          kuFilterHeadElements.forEach((element) => {
            element.classList.add(selectors.kuExpand.substring(1));
            element.classList.remove(selectors.kuCollapse.substring(1));
          });

          // Replace .kuFilterNames.kuCollapse with .kuFilterNames.kuExpand
          const kuFilterNamesElements = document.querySelectorAll(
            selectors.kuFilterNames
          );
          kuFilterNamesElements.forEach((element) => {
            element.classList.add(selectors.kuFilterCollapse.substring(1));
            element.classList.remove(selectors.kuFilterShowAll.substring(1));
          });
        })();

        // Regular checkbox-facets
        // Check if the required elements exist
        const kuSelectedElements = document.querySelectorAll(
          selectors.kuFilterBox + ' ' + selectors.kuSelected
        );
        if (kuSelectedElements.length > 0) {
          kuSelectedElements.forEach((selectedElement) => {
            // Find the parent element with the class kuFilterBox
            const filterBoxParent = findParentWithClass(
              selectedElement,
              selectors.kuFilterBox
            );

            // Look for the child with the class kuFilterHead.kuExpand
            const filterHeadChild = filterBoxParent.querySelector(
              selectors.kuFilterHeadExpand
            );

            // Rotate icon in the title
            if (filterHeadChild) {
              filterHeadChild.classList.remove('kuExpand');
              filterHeadChild.classList.add('kuCollapse');
            }

            // Find the parent element with the class kuFilterNames.kuFilterCollapse
            const filterNamesParent = findParentWithClass(
              selectedElement,
              selectors.kuFilterNamesCollapse
            );

            // Show options
            if (filterNamesParent) {
              filterNamesParent.classList.remove('kuFilterCollapse');
              filterNamesParent.classList.add(
                selectors.kuFilterShowAll.substring(1)
              );
            }
          });
        }

        // Price slider facet
        var isThereAnyAppliedFacets = klevu.getObjectPath(
          scope.kScope.data,
          'localOverrides.query.' +
            scope.kScope.data.context.activeQueryId +
            '.filters.applyFilters.filters'
        );
        const isPriceFacetApplied = Boolean(
          isThereAnyAppliedFacets?.filter((val) => val.key === 'klevu_price')
            .length
        );
        if (isPriceFacetApplied) {
          // Find the parent element with the class kuFilterNames.kuFilterCollapse
          const nouiElement = document.querySelector(
            `${selectors.priceFacetBlock} ${selectors.nouiElement}`
          );

          if (nouiElement) {
            const filterNamesParent = findParentWithClass(
              nouiElement,
              selectors.kuFilterNamesCollapse
            );

            // Show options
            if (filterNamesParent) {
              filterNamesParent.classList.remove('kuFilterCollapse');
              filterNamesParent.classList.add(
                selectors.kuFilterShowAll.substring(1)
              );
            }

            // Find the parent element with the class kuFilterBox
            const filterBoxParent = findParentWithClass(
              nouiElement,
              selectors.kuFilterBox
            );

            // Look for the child with the class kuFilterHead.kuExpand
            const filterHeadChild = filterBoxParent.querySelector(
              selectors.kuFilterHeadExpand
            );

            // Rotate icon in the title
            if (filterHeadChild) {
              filterHeadChild.classList.remove('kuExpand');
              filterHeadChild.classList.add('kuCollapse');
            }
          }
        }

        // Function-helper to find the parent element with a specified class
        function findParentWithClass(element, className) {
          let parent = element.parentElement;
          while (parent) {
            if (parent.matches(className)) {
              return parent;
            }
            parent = parent.parentElement;
          }
          return null; // No matching parent found
        }
      },
      filterToggler: function (documentBody, klevuLanding) {
        klevu.event.attach(klevuLanding, 'click', function ({ target }) {
          if (target.matches('.ku-filter-toggler, .ku-filter-toggler *')) {
            documentBody.classList.add('klevu-filters-opened');
          } else if (
            target.matches(
              '.klevu-close-filters, .klevu-close-filters *, .kuFiltersButton_apply, .kuFiltersButton_apply *'
            )
          ) {
            documentBody.classList.remove('klevu-filters-opened');
          }
        });
      },
      smoothScrollToProductListingTop: function () {
        let customOffset = 60;
        const selectorsToTriggerScrollToTop = {
          pagination: '.kuPagination a',
          // filterOptions: '.klevuFilterOption',
          // Add more selectors here as needed
        };
        function _smoothScrollToKlevuTop() {
          setTimeout(function () {
            var target = document.getElementsByClassName('klevuMeta')[0];

            if (target) {
              var topPosition =
                target.getBoundingClientRect().top + window.pageYOffset;

              window.scrollTo({
                top: topPosition - customOffset,
                behavior: 'smooth',
              });
            }
          }, 100);
        }
        Object.values(selectorsToTriggerScrollToTop).forEach((selector) => {
          document
            .querySelectorAll(selector)
            .forEach((el) =>
              el.addEventListener('click', _smoothScrollToKlevuTop)
            );
        });
      },
    });
  })(klevu);

  try {
    if (scope.kScope.tabResultsList?.indexOf('assemblyFiles') === -1) {
      var productListIndex = scope.kScope.tabResultsList.indexOf('productList');
      if (productListIndex === -1) {
        productListIndex = 0;
      } else {
        productListIndex++;
      }
      scope.kScope.tabResultsList.splice(productListIndex, 0, 'assemblyFiles');
    }
  } catch (err) {
    console.log(
      "(KLEVU) We could not find 'productList' in the list of tabs",
      err
    );
  }
});

klevu.modifyRequest('catnav,landing', function (data, scope) {
  var parameterMap = klevu.getSetting(
    scope.kScope.settings,
    'settings.search.map',
    false
  );
  var assemblyFiles = klevu.extend(true, {}, parameterMap.recordQuery);
  assemblyFiles.id = 'assemblyFiles';
  assemblyFiles.typeOfRequest = 'SEARCH';
  assemblyFiles.settings.query.term = data.context.term;
  assemblyFiles.settings.typeOfRecords = [
    'KLEVU_CATEGORY',
    'KLEVU_PRODUCT',
    'KLEVU_MANUAL',
  ];
  assemblyFiles.settings.searchPrefs = ['searchCompoundsAsAndQuery'];
  assemblyFiles.settings.limit = 300;
  assemblyFiles.filters.filtersToReturn.enabled = false;
  data.request.current.recordQueries.push(assemblyFiles);
  data.context.doSearch = true;

  klevu.each(data.request.current.recordQueries, function (key, query) {
    klevu.setObjectPath(query, 'filters.filtersToReturn.options.limit', 100);

    // No results limit
    const queryID = klevu.getObjectPath(query, 'id');
    if (queryID === 'noResultsFoundPopularProductList') {
      klevu.setObjectPath(query, 'settings.limit', 10);
    }
    // No results limit END
  });

  // klevu.modifyResponse('landing', function (data, scope) {
  //   klevu.each(
  //     data.template.query.productList.result,
  //     function (indx, product) {
  //       console.log('Klevu Response Product ' + indx, product);
  //     }
  //   );
  // });

  // Restore Search Params On Page Load
  klevu.search.modules.addParamsToURL.base.restoreSearchParamsOnPageLoad(
    data,
    scope
  );

  // set the global scope
  window.klevuCurrentScope = scope.kScope;
});

klevu.afterTemplateRender('catnav,landing', function (data, scope) {
  const documentBody = document.body;
  const klevuLanding = document.getElementsByClassName('klevuLanding')[0];
  const isThisPageCategory = !klevu.getSetting(
    klevu,
    'settings.flags.setRemoteConfigLanding.build'
  );

  klevu.search.modules.addParamsToURL.base.addURLtoHistory(data, scope);
  klevu.search.modules.keepFacetsWithSelectedOptionsOpened();
  klevu.search.modules.filterToggler(documentBody, klevuLanding);
  klevu.search.modules.smoothScrollToProductListingTop();

  if (isThisPageCategory && documentBody) {
    documentBody.classList.add('klevu-category-page');
  }
});

// Render calling native Shopify card
klevu.afterTemplateRender('landing,catnav', async function (data, scope) {
  try {
    var productIds = data.template.query.productList.result;

    await Promise.all(
      productIds.map(async (prod) => {
        try {
          var productCardHolder = document.querySelector(
            '[data-id="' + prod.id + '"] div.kuProdWrapHolder'
          );
          if (!productCardHolder) return;

          var res = await fetch(
            prod.url + '?view=klevu-template&variant=' + prod.id
          );

          if (res.ok) {
            var templateBlock = await res.text();
            productCardHolder.innerHTML = templateBlock;

            // get the product card component and initialize it

            const productCard = productCardHolder.querySelector(
              '[data-component="productCard"]'
            );
            document.dispatchEvent(
              new CustomEvent('shopify:section:load:product-cards', {
                detail: {
                  node: productCard,
                },
              })
            );
          } else {
            console.warn('[Klevu] Product card fetch failed (' + res.status + '):', prod.url + '?view=klevu-template&variant=' + prod.id);
            var productBlock = productCardHolder.closest('[ku-product-block]');
            (productBlock || productCardHolder).remove();
          }
        } catch (err) {
          console.warn('[Klevu] Product card fetch error:', prod.url, err);
          if (productCardHolder) {
            var productBlock = productCardHolder.closest('[ku-product-block]');
            (productBlock || productCardHolder).remove();
          }
        }
      })
    );

    // get the style collection button and initialize it
    const styleCollectionButton = document.querySelector(
      '[data-component="styleCollection"]'
    );
    document.dispatchEvent(
      new CustomEvent('shopify:section:load:style-collection', {
        detail: { node: styleCollectionButton },
      })
    );

    // call assembly files results
    const assemblyFilesResults = document.querySelector(
      '[data-results-assembly-files]'
    );

    if (assemblyFilesResults) {
      document.dispatchEvent(
        new CustomEvent('search-files:get-assembly-files', {
          detail: {
            node: assemblyFilesResults,
            searchTerm: data.template.query.assemblyFiles.meta.searchedTerm,
          },
        })
      );
    }
  } catch (err) {
    console.log('Global render error:', err);
  }
});

window.onpopstate = function (event) {
  try {
    // passing activeQueryId because it's lost once we reset the data below
    var activeQueryId = klevu.getObjectPath(
      window.klevuCurrentScope.element.kObject.getScope().data,
      'context.activeQueryId'
    );
    // code to get ready to reset all the data
    var data = window.klevuCurrentScope.element.kObject.getScope().data;
    var scope = window.klevuCurrentScope.element;
    scope.kScope.data = scope.kObject.resetData(scope.kElem);
    scope.kScope.data.context.keyCode = 0;
    scope.kScope.data.context.eventObject = event;
    scope.kScope.data.context.event = 'keyUp';
    scope.kScope.data.context.preventDefault = false;

    // Get payload for Filters & Pagination
    klevu.search.modules.addParamsToURL.base.updatePayloadOnPopState(
      data,
      scope,
      activeQueryId
    );

    // Fire request, re-render results
    klevu.event.fireChain(
      scope.kScope,
      'chains.events.keyUp',
      scope,
      scope.kScope.data,
      event
    );
  } catch (error) {
    console.log(error);
  }
};
/* ============ LANDING & CATNAV TEMPLATES ============= */

var klevuLandingTemplateProductBlockCustom2 = `
 <li ku-product-block class="klevuProduct klevuProductClick kuTrackRecentView grid__item" data-id="<%=dataLocal.id%>">
    <div class="kuProdWrapHolder">
      <!-- Rendered card-product markup will be injected here -->
    </div>
  </li>
`;
var klevuLandingTemplateProductBlockCustom = `
<%
    var updatedProductName = dataLocal.name;
    <!-- customization -->
    if(typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') {
        updatedProductName = updatedProductName.replace(dataLocal.brand, '');
    }
    <!-- customization end -->
%>
<li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>">
    <div class="kuProdWrap">
        <header ku-block data-block-id="ku_landing_result_item_header">
            <%=helper.render('landingProductBadge', scope, data, dataLocal) %>
        </header>
        <% var desc = [dataLocal.summaryAttribute,dataLocal.packageText,dataLocal.summaryDescription].filter(function(el) { return el; }); desc = desc.join(" "); %>
        <main ku-block data-block-id="ku_landing_result_item_info">
            <div class="kuProdTop">
                <!-- customization -->
                <div class="klevuImgWrap">
                    <a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView">
                        <img src="<%=dataLocal.image.replace('_medium', '_500x500')%>" origin="<%=dataLocal.image.replace('_medium', '_500x500')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
                        <%=helper.render('landingImageRollover', scope, data, dataLocal) %>
                    </a>
                    <%=helper.render('landingPageProductAddToCart',scope,data,dataLocal) %>
                </div>
                <%=helper.render('landingProductSwatch',scope,data,dataLocal) %>
                <%=helper.render('klevuLandingProductRating',scope,data,dataLocal) %>

                <!-- customization end -->
            </div>
        </main>
        <footer ku-block="" data-block-id="ku_landing_result_item_footer">
            <div class="kuProdBottom">
                <!-- customization -->
                <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
                    <div class="klevu-brand"><%= dataLocal.brand %></div>
                <% } %>
                <!-- customization end -->
                <div class="kuName kuClippedOne"><a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView" title="<%= updatedProductName %>"><%= updatedProductName %></a></div>

                <!-- customization -->
                <% if(desc && desc.length) { %>
                        <div class="kuDesc kuClippedTwo"> <%=desc%> </div>
                <% } %>
                <!-- customization end -->

                <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                    <%=helper.render('landingProductStock', scope, data, dataLocal) %>
                <% } else { %>
                <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                    <div class="kuPrice">
                        <%
                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                            var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                        %>
                        <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>
                            <div class="kuSalePrice kuStartPrice kuClippedOne">
                                <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span>
                                <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>
                            </div>
                        <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                            <span class="kuOrigPrice kuClippedOne">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                            <span class="kuSalePrice kuSpecialPrice kuClippedOne">
                                <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                            </span>
                        <% } else if(!Number.isNaN(kuSalePrice)) { %>
                            <span class="kuSalePrice kuSpecialPrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                            </span>
                        <% } else if(!Number.isNaN(kuPrice)) { %>
                            <span class="kuSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                        <% } %>
                        <%=helper.render('searchResultProductVATLabel', scope, data, dataLocal) %>
                    </div>
                <% } %>
                <% } %>
            </div>
            <div class="kuProdAdditional">
                <!-- customization -->
                <!-- customization end -->
            </div>
        </footer>
    </div>
</li>`;

var landingPageProductAddToCartCustom = `
<% if(dataLocal.inStock != "no") { %>
<% var addToCartCaption = klevu.search.modules.kmcInputs.base.getAddToCartButtonCaption(); %>
    <% if(addToCartCaption && addToCartCaption.indexOf("<img") !== -1) { %>
        <div class="kuAddtocart kuLandingAddToCartBtn" data-id="<%=dataLocal.id%>" role="button" tabindex="0" area-label="Add to cart">
            <%= addToCartCaption %>
        </div>
    <% } else { %>
        <div class="kuAddtocart kuLandingAddToCartBtn" data-id="<%=dataLocal.id%>" role="button" tabindex="0" area-label="<%= addToCartCaption %>">
            <%=helper.translate(addToCartCaption) %>
        </div>
    <% } %>
<% } %>`;

var KlevuLandingTemplateResultsCustom = `
  <%
    var klevu_ads_enabled = false;
    if (typeof klevu_ads === 'object') {
      klevu_ads_enabled = true
    }
  %>

<div class="kuResultsListing">
    <div class="productList klevuMeta" data-section="productList">
        <div class="kuResultContent">
            <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                    <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                        <div ku-block data-block-id="ku_landing_left_facets">
                            <%=helper.render('filters',scope,data,"productList") %>
                        </div>
                        <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_left_banner"></div>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">

                        <header ku-block data-block-id="ku_landing_result_header">
                            <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                                <button class="ku-filter-toggler">
                                    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.55372 7.58824L1 7.58825M11.1818 7.58825L8.40496 7.58824M2.85124 2.41177L1 2.41173M11.1818 2.41173L4.70248 2.41177M4.70248 1V3.82352M8.40496 9V6.17648" stroke="#151515" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>

                                    <span><%= helper.translate("Filters")%></span>
                                </button>
                            <%=helper.render('filtersTop',scope,data,"productList") %>
                            <% if(helper.hasResults(data,"productList")) { %>
                                <%=helper.render('sortBy',scope,data,"productList") %>
                            <% } %>
                            <div class="flex col-span-2 max-w-max md:hidden flex-row p-1 border border-solid bg-gray-05 border-gray-20 rounded-[10px] mr-8" data-collection-switches="" data-component="styleCollection" style="display: none !important;">
                              <button class="bg-gray-05 border border-gray-05 focus:bg-gray-05  focus:border-gray-05 focus-visible:bg-gray-05 focus-visible:border-2 focus-visible:border-gray-05 focus:outline-none focus-visible:outline-none disabled:bg-transparent disabled:text-gray-30 disabled:border-gray-30 backdrop-blur-lg h-12 py-3 px-5  rounded-lg flex justify-center items-center font-extrabold  text-gray-90 !border-gray-20 hover:!bg-gray-10 !bg-gray-10 text-base" data-collection-switch="product">Product
                              </button>
                              <button class="bg-gray-05 border border-gray-05 hover:bg-gray-10 focus:bg-gray-05  focus:border-gray-05 focus-visible:bg-gray-05 focus-visible:border-2 focus-visible:border-gray-05 focus:outline-none focus-visible:outline-none disabled:bg-transparent disabled:text-gray-30 disabled:border-gray-30 backdrop-blur-lg h-12 py-3 px-5  rounded-lg flex justify-center items-center font-extrabold  text-gray-70 text-base" data-collection-switch="lifestyle">Lifestyle
                              </button>
                            </div>
                            <div class="kuClearBoth"></div>
                        </header>

                        <div ku-block data-block-id="ku_landing_result_items">
                        <%= helper.render('kuFilterTagsTemplate',scope,data,"productList") %>

                            <div class="kuResults">
                                <% if(helper.hasResults(data,"productList")) { %>
                                        <ul>
                                            <% helper.each(data.query.productList.result,function(key,item){
                                                  var thisAd, klevu_ad_enabled = false;
                                                  /* Here we identify if there should be an ad for this productBlock */

                                                  // for some reason window.pageType is null, so I set up a variable in ads.liquid with the template name

                                                  helper.each(klevu_ads,function(keyAd,itemAd){
                                                    klevu_ad_enabled = false;
                                                    if (itemAd.template_type === 'collection' && (itemAd.show_all_collections === true || itemAd.collection_list.indexOf(klevu_pageCategory) !== -1) && itemAd.position === key) {
                                                      klevu_ad_enabled = true;
                                                    }

                                                    if (klevu_ad_enabled) {
                                                      thisAd = itemAd;
                                                    %>
                                                      <li ku-product-block class="klevuProduct">
                                                        <div class="kuProdWrap">
                                                          <div class='flex h-full md:h-[calc(100%-36px)] w-full flex-col justify-between rounded-xl bg-gray-20 p-2 '>
                                                            <div class="relative h-full">

                                                              <% if (thisAd.url.length) { %>
                                                                <a href="<%=thisAd.url%>" class="relative h-full">
                                                              <% } %>
                                                              <% if (thisAd.media_type === 'image') { %>
                                                                <%=thisAd.image%>
                                                              <% } else { %>
                                                                <%=thisAd.video%>
                                                              <% } %>
                                                                <% if (thisAd.add_overlay) { %>
                                                                  <div class="absolute bottom-0 top-0 left-0 w-full"
                                                                    style="
                                                                      height: <%=thisAd.overlay_gradient_height%>%;
                                                                      background: linear-gradient(to bottom,<%=thisAd.overlay_color%>,<%=thisAd.overlay_gradient_opacity%>) 0%,<%=thisAd.overlay_color%>,0) 100%);
                                                                    ">
                                                                </div>
                                                                <% } %>
                                                              <% if (thisAd.url.length) { %>
                                                                </a>
                                                              <% } %>
                                                              <div class="px-4 py-4 md:p-4 flex flex-col gap-2 absolute top-0 left-0">
                                                                <h3 class="text-lg-medium md:text-xl-medium" style="color: <%=thisAd.text_color%>;"><%=thisAd.alt%></h3>
                                                                <div class="text-sm-regular" style="color: <%=thisAd.text_color%>;">
                                                                  <%=thisAd.description%>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <% if (thisAd.button_text.length) { %>
                                                            <a href="<%=thisAd.url%>" class="text-sm-bold md:text-md-bold flex flex-row gap-2 items-center justify-center bg-white-60 border border-solid border-black-10 p-2 rounded-lg">
                                                              <%=thisAd.button_text%>
                                                              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                                                <path d="M15.9352 10.0828L11.9055 8.59375L10.4211 4.56094C10.3332 4.32213 10.1742 4.11604 9.96549 3.97046C9.75677 3.82488 9.50843 3.74682 9.25396 3.74682C8.99949 3.74682 8.75114 3.82488 8.54243 3.97046C8.33371 4.11604 8.17467 4.32213 8.08677 4.56094L6.59302 8.59375L2.56021 10.0781C2.3214 10.166 2.11531 10.3251 1.96973 10.5338C1.82415 10.7425 1.74609 10.9908 1.74609 11.2453C1.74609 11.4998 1.82415 11.7481 1.96973 11.9568C2.11531 12.1656 2.3214 12.3246 2.56021 12.4125L6.59302 13.9062L8.0774 17.9391C8.1653 18.1779 8.32434 18.384 8.53305 18.5295C8.74177 18.6751 8.99011 18.7532 9.24458 18.7532C9.49905 18.7532 9.7474 18.6751 9.95611 18.5295C10.1648 18.384 10.3239 18.1779 10.4118 17.9391L11.9055 13.9062L15.9383 12.4219C16.1771 12.334 16.3832 12.1749 16.5288 11.9662C16.6744 11.7575 16.7524 11.5092 16.7524 11.2547C16.7524 11.0002 16.6744 10.7519 16.5288 10.5432C16.3832 10.3344 16.1771 10.1754 15.9383 10.0875L15.9352 10.0828ZM11.2024 12.8297C11.1176 12.861 11.0405 12.9103 10.9766 12.9742C10.9126 13.0381 10.8633 13.1152 10.8321 13.2L9.24927 17.4883L7.66958 13.2031C7.63837 13.1174 7.58876 13.0395 7.52424 12.975C7.45973 12.9105 7.38188 12.8609 7.29615 12.8297L3.01099 11.25L7.29615 9.67031C7.38188 9.6391 7.45973 9.58949 7.52424 9.52497C7.58876 9.46046 7.63837 9.38261 7.66958 9.29688L9.24927 5.01172L10.829 9.29688C10.8602 9.38171 10.9095 9.45875 10.9735 9.52269C11.0374 9.58662 11.1144 9.63592 11.1993 9.66719L15.4876 11.25L11.2024 12.8297ZM11.7493 3.125C11.7493 2.95924 11.8151 2.80027 11.9323 2.68306C12.0495 2.56585 12.2085 2.5 12.3743 2.5H13.6243V1.25C13.6243 1.08424 13.6901 0.925268 13.8073 0.808058C13.9245 0.690848 14.0835 0.625 14.2493 0.625C14.415 0.625 14.574 0.690848 14.6912 0.808058C14.8084 0.925268 14.8743 1.08424 14.8743 1.25V2.5H16.1243C16.29 2.5 16.449 2.56585 16.5662 2.68306C16.6834 2.80027 16.7493 2.95924 16.7493 3.125C16.7493 3.29076 16.6834 3.44973 16.5662 3.56694C16.449 3.68415 16.29 3.75 16.1243 3.75H14.8743V5C14.8743 5.16576 14.8084 5.32473 14.6912 5.44194C14.574 5.55915 14.415 5.625 14.2493 5.625C14.0835 5.625 13.9245 5.55915 13.8073 5.44194C13.6901 5.32473 13.6243 5.16576 13.6243 5V3.75H12.3743C12.2085 3.75 12.0495 3.68415 11.9323 3.56694C11.8151 3.44973 11.7493 3.29076 11.7493 3.125ZM19.8743 6.875C19.8743 7.04076 19.8084 7.19973 19.6912 7.31694C19.574 7.43415 19.415 7.5 19.2493 7.5H18.6243V8.125C18.6243 8.29076 18.5584 8.44973 18.4412 8.56694C18.324 8.68415 18.165 8.75 17.9993 8.75C17.8335 8.75 17.6745 8.68415 17.5573 8.56694C17.4401 8.44973 17.3743 8.29076 17.3743 8.125V7.5H16.7493C16.5835 7.5 16.4245 7.43415 16.3073 7.31694C16.1901 7.19973 16.1243 7.04076 16.1243 6.875C16.1243 6.70924 16.1901 6.55027 16.3073 6.43306C16.4245 6.31585 16.5835 6.25 16.7493 6.25H17.3743V5.625C17.3743 5.45924 17.4401 5.30027 17.5573 5.18306C17.6745 5.06585 17.8335 5 17.9993 5C18.165 5 18.324 5.06585 18.4412 5.18306C18.5584 5.30027 18.6243 5.45924 18.6243 5.625V6.25H19.2493C19.415 6.25 19.574 6.31585 19.6912 6.43306C19.8084 6.55027 19.8743 6.70924 19.8743 6.875Z" fill="currentColor"></path>
                                                              </svg>
                                                            </a>
                                                            <% } %>
                                                          </div>
                                                        </div>
                                                      </li>
                                                    <% }
                                                  });
                                              %>

                                              <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %>
                                                  <%=helper.render('productBlock',scope,data,item) %>
                                              <% } %>
                                            <% }); %>
                                        </ul>
                                <% } else { %>
                                    <div class="kuNoRecordsFoundLabelTextContainer">
                                        <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                    </div>
                                <% } %>
                                <div class="kuClearBoth"></div>
                            </div>
                            <%=helper.render('pagination',scope,data,"productList") %>
                        </div>

                        <div ku-block data-block-id="ku_landing_other_items">
                            <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                        </div>
                        <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                        <div ku-block data-block-id="ku_landing_right_facets"></div>
                        <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_right_banner"></div>
                    </section>
                </div>

            </div>
        </div>
    </div>

    <% if(data.query.contentList) { %>
        <div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
            <div class="kuResultContent">
                <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                    <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                        <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                            <div ku-block data-block-id="ku_landing_left_facets">

                                <%=helper.render('filters',scope,data,"contentList") %>

                            </div>
                            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_left_banner"></div>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">

                            <header ku-block data-block-id="ku_landing_result_header">
                                <%=helper.render('filtersTop',scope,data,"contentList") %>
                                <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %>
                                <div class="kuClearBoth"></div>
                            </header>

                            <div ku-block data-block-id="ku_landing_result_items">
                                <div class="kuClearBoth"></div>
                                <div class="kuResults">
                                    <% if(helper.hasResults(data,"contentList")) { %>
                                        <ul>
                                            <% helper.each(data.query.contentList.result,function(key,item){ %>
                                                <% if(item.typeOfRecord == "KLEVU_CMS") { %>
                                                    <%=helper.render('contentBlock',scope,data,item) %>
                                                <% }%>
                                            <% }); %>
                                        </ul>
                                    <% } else { %>
                                        <div class="kuNoRecordsFoundLabelTextContainer">
                                            <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                        </div>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </div>
                                <%=helper.render('pagination',scope,data,"contentList") %>
                            </div>
                            <div ku-block data-block-id="ku_landing_other_items">
                                <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                            </div>
                            <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                            <div ku-block data-block-id="ku_landing_right_facets"></div>
                            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_right_banner"></div>
                        </section>
                    </div>

                </div>
            </div>
        </div>
    <% } %>

    <!-- Show assembly files results -->
    <% var searchTerm = (typeof data.settings !== 'undefined' && typeof data.settings.term !== 'undefined') ? data.settings.term : '' %>
    <% if(data.query.assemblyFiles && searchTerm.length > 1 && false) { %>
      <div class="assemblyFiles klevuMeta" data-section="assemblyFiles" data-result-view="list">
        <h3 class="text-lg w-full text-center mx-auto font-bold"><%= helper.translate("Assembly Files") %></h3>
        <div class="kuResultContent">
            <div class="kuResultWrap <%=(data.query.assemblyFiles.filters.length == 0 )?'kuBlockFullwidth':''%>">

                <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                    <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                        <div ku-block data-block-id="ku_landing_left_facets">

                            <%=helper.render('filters',scope,data,"assemblyFiles") %>

                        </div>
                        <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_left_banner"></div>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">

                        <header ku-block data-block-id="ku_landing_result_header">
                            <%=helper.render('filtersTop',scope,data,"assemblyFiles") %>
                            <%= helper.render('kuFilterTagsTemplate',scope,data,"assemblyFiles") %>
                            <div class="kuClearBoth"></div>
                        </header>

                        <div ku-block data-block-id="ku_landing_result_items">
                            <div class="kuClearBoth"></div>
                            <div class="kuResults">

                                <div data-results-assembly-files></div>

                                <div class="kuClearBoth"></div>
                            </div>
                        </div>
                        <div ku-block data-block-id="ku_landing_other_items">
                            <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                        </div>
                        <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                        <div ku-block data-block-id="ku_landing_right_facets"></div>
                        <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_right_banner"></div>
                    </section>
                </div>

            </div>
        </div>
    </div>
    <% } %>
</div>`;

var klevuLandingTemplateSearchBarCustom = `
<%
    var totalProductResultsFound = klevu.getObjectPath(data,"query.productList.meta.totalResultsFound", 0);
    var totalContentResultsFound = klevu.getObjectPath(data,"query.contentList.meta.totalResultsFound", 0);
    var resultText = 'Results';
    if((totalProductResultsFound + totalContentResultsFound) === 1){
        resultText = 'Result';
    }
 %>
<% var searchTerm = (typeof data.settings !== 'undefined' && typeof data.settings.term !== 'undefined') ? data.settings.term : '' %>
<% var queryParam = klevu.getGlobalSetting("url.queryParam"); %>
<h1 class="klevu-search-title"><%=helper.translate("Search Results")%></h1>
<div class="kuSearchResultsSearchBarContainer kuHideExtraSearch">
    <form action="/" method="get">
        <input type="text" name="<%= queryParam %>" id="search" class="kuSearchInput header-bar__search-input" placeholder="<%=helper.translate("Search text")%>" />
    </form>
</div>

<div class="klevu-total-results">
    <%=totalProductResultsFound + totalContentResultsFound %> <%= helper.translate(resultText) %> <%= helper.translate("found for")%> "<%=searchTerm%>"
</div>`;

var klevuLandingTemplatePaginationCustom = `
<% if(data.query[dataLocal].result.length > 0 ) { %>
    <%
        var resultsPerPage = data.query[dataLocal].meta.noOfResults;
        var totalResultsFound = data.query[dataLocal].meta.totalResultsFound - 1;
        const lastPageOffset = (Math.floor(totalResultsFound/resultsPerPage)*resultsPerPage);
        const currentOffset = data.query[dataLocal].meta.offset;
        const productListLimit = data.query.productList.meta.noOfResults;
        const currentPage = (Math.ceil(currentOffset/resultsPerPage)+1);
        const customOffsetPrev = currentOffset - productListLimit;
        const customOffsetNext = (currentOffset + (resultsPerPage)) >= lastPageOffset ? lastPageOffset : (currentOffset + (resultsPerPage));
        const customOffsetPrevTotRes = currentPage <= 1 ? 1 : (productListLimit * (currentPage - 1));
        const totalPages = (Math.ceil(totalResultsFound/resultsPerPage));
        const isLastPage = currentPage === totalPages;
        const productListTotal = data.query.productList.meta.totalResultsFound - 1;
        const lastPage = (Math.ceil(productListTotal/productListLimit) - currentPage) >= 1 ? (Math.ceil(productListTotal/productListLimit)) : 0;
        const toProducts = data.query.productList.meta.offset+productListLimit >= productListTotal ? productListTotal : data.query.productList.meta.offset+productListLimit;
    %>
    <div class="kuPagination kuPagination--custom">

        <div class="klevuPaginate-wrapper">

            <% if(currentOffset > 0) { %>
                <a target="_self" href="javascript:void(0)"  class="klevuPaginate klevuPaginate_prev" rel="prev" data-offset="<%= customOffsetPrev %>"><svg style="pointer-events: none;" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 4H6H1M1 4L4.28467 1M1 4L4.28467 7" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg></a>
            <% } %>

            <% if (currentPage === 2) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - resultsPerPage)%>"><%=(Math.ceil(currentOffset/resultsPerPage))%></a>
            <% } %>
            <% if (currentPage >= 3) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - (resultsPerPage * 2))%>"><%=(Math.ceil(currentOffset/resultsPerPage)-1)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - resultsPerPage)%>"><%=(Math.ceil(currentOffset/resultsPerPage))%></a>
            <% } %>

            <a href="javascript:void(0);" class="kuCurrent"><%=(Math.ceil(currentOffset/resultsPerPage)+1)%></a>



            <% if(totalResultsFound >= currentOffset + resultsPerPage) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+resultsPerPage)%>"><%=(Math.ceil(currentOffset/resultsPerPage)+2)%></a>
            <% } %>
            <% if (totalPages - currentPage === 2) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffset/resultsPerPage)+3)%></a>
            <% } %>
            <% if (totalPages - currentPage >= 3) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffset/resultsPerPage)+3)%></a>
            <% } %>
            <% if (totalPages - currentPage >= 4) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+(resultsPerPage * 3))%>"><%=(Math.ceil(currentOffset/resultsPerPage)+4)%></a>
            <% } %>

            <% if(totalResultsFound >= currentOffset + resultsPerPage && totalPages > 3) { %>
                <a target="_self" href="javascript:void(0)" rel="next" class="klevuPaginate klevuPaginate_next" data-offset="<%=customOffsetNext%>"><svg width="12" style="pointer-events: none;" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 4H6H11M11 4L7.71533 1M11 4L7.71533 7" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg></a>
            <% } %>

        </div>
    </div>

<% } %>`;

var klevuLandingTemplateFiltersCustom = `
<%
    var totalResultsFoundText = helper.translate("Result");
    if(data.query["productList"]?.meta.totalResultsFound > 1){
        totalResultsFoundText = helper.translate("Results");
    }
%>
<% if(data.query[dataLocal].filters.length > 0 ) { %>
    <div class="kuFiltersWrapper">
        <div class="kuFiltersHeader">
            <span><%= helper.translate("Filters")%></span>
            <div class='klevu-total-products'><%=data.query["productList"]?.meta.totalResultsFound%> <%=totalResultsFoundText%></div>
            <button class="klevu-close-filters">
                <svg class="icon" role="img" aria-label="Close">
                    <use xlink:href="#icon-close"><svg viewBox="0 0 612 612" id="icon-close">
                        <polygon points="612,36.004 576.521,0.603 306,270.608 35.478,0.603 0,36.004 270.522,306.011 0,575.997 35.478,611.397 306,341.411 576.521,611.397 612,575.997 341.459,306.011 "></polygon>
                    </svg></use>
                </svg>
            </button>
        </div>
        <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">
            <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
                <% if(filter.type == "OPTIONS"){ %>

                <%
                  var hideFilterOption = false;
                  if((filter.collectionHandle == 'murphy-beds' || filter.collectionHandle == 'lits-escamotables') && filter.key == 'Bedroom_Filter') {
                    hideFilterOption = true;
                  }
                  if((filter.collectionHandle == 'murphy-beds' || filter.collectionHandle == 'lits-escamotables') && filter.key == 'size') {
                    hideFilterOption = true;
                  }
                  if((filter.collectionHandle == 'cabinet-beds' || filter.collectionHandle == 'lits-armoires') && filter.key == 'Bedroom_Filter') {
                    hideFilterOption = true;
                  }
                  if((filter.collectionHandle == 'cabinet-beds' || filter.collectionHandle == 'lits-armoires') && filter.key == 'size') {
                    hideFilterOption = true;
                  }
                  if((filter.collectionHandle == 'cabinet-beds' || filter.collectionHandle == 'lits-armoires') && filter.key == 'Category_Custom') {
                    hideFilterOption = true;
                  }
                  if((filter.collectionHandle == 'desks'  || filter.collectionHandle == 'bureaux')&& filter.key == 'Bedroom_Filter') {
                    hideFilterOption = true;
                  }
                  if((filter.collectionHandle == 'bedroom'  || filter.collectionHandle == 'chambre-a-coucher')&& filter.key == 'Category_Custom') {
                    hideFilterOption = true;
                  }
                  if((filter.collectionHandle == 'bedroom'  || filter.collectionHandle == 'chambre-a-coucher')&& filter.key == 'size') {
                    hideFilterOption = true;
                  }
                  if((filter.collectionHandle == 'home-office' || filter.collectionHandle == 'bureau-a-domicile') && filter.key == 'Bed_Size') {
                    hideFilterOption = true;
                  }
                  if((filter.collectionHandle == 'living-room' || filter.collectionHandle == 'salon') && filter.key == 'Category_Custom') {
                    hideFilterOption = true;
                  }
                  if(filter.collectionHandle == 'pur-collection' && filter.key == 'Category_Custom') {
                    hideFilterOption = true;
                  }
                  if(filter.collectionHandle == 'pur-collection' && filter.key == 'Bed_Size') {
                    hideFilterOption = true;
                  }
                  if(filter.collectionHandle == 'pur-collection' && filter.key == 'Collection') {
                    hideFilterOption = true;
                  }
                  if(filter.collectionHandle == 'avalon-collection' && filter.key == 'Bedroom_Filter') {
                    hideFilterOption = true;
                  }
                  if(filter.collectionHandle == 'borealis-collection' && filter.key == 'Bedroom_Filter') {
                    hideFilterOption = true;
                  }
                  if(filter.collectionHandle == 'lumina-collection' && filter.key == 'Bedroom_Filter') {
                    hideFilterOption = true;
                  }
                  if(filter.collectionHandle == 'edge-collection' && filter.key == 'Bedroom_Filter') {
                    hideFilterOption = true;
                  }
                  if(filter.collectionHandle == 'key-west-collection' && filter.key == 'Bedroom_Filter') {
                    hideFilterOption = true;
                  }
                  if(filter.collectionHandle == 'versatile-collection' && filter.key == 'Bedroom_Filter') {
                    hideFilterOption = true;
                  }
                  if(filter.collectionHandle == 'orion-collection' && filter.key == 'Bedroom_Filter') {
                    hideFilterOption = true;
                  }
                  if(filter.collectionHandle == 'barletta-collection' && filter.key == 'Category_Custom') {
                    hideFilterOption = true;
                  }
                %>

                    <div class="<% if (hideFilterOption) { %> hidden <% } %> kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul <% if (filter.key == "Color_Filter" || filter.key == "bed_style") { %> class="flex flex-wrap gap-2" <% } %>>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li class="<% if(filterOption.selected ==true) { %>kuSelected<% } %>" <% if (filter.key == "Color_Filter" || filter.key == "bed_style") { %> style="width: max-content;" <% } %>>
                                        <a
                                            target="_self"
                                            href="#"
                                            title="<%=helper.escapeHTML(filterOption.name)%>"
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>"
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kuFilterIcon <% if (filter.key == "Color_Filter" || filter.key == "bed_style") { %> !hidden <% } %>"></span>
                                            <span class="kufacet-text">
                                              <% if (filter.key == "Color_Filter") { %>
                                                <%
                                                  var color_bg =
                                                    filterOption.name === 'Brown' || filterOption.name === 'Brun'
                                                      ? '#504034'
                                                      : filterOption.name === 'Charcoal' || filterOption.name === 'Charbon'
                                                      ? '#4e4b48'
                                                      : filterOption.name === 'Gray' || filterOption.name === 'Gris'
                                                      ? '#808080'
                                                      : filterOption.name === 'White' || filterOption.name === 'Blanc'
                                                      ? '#ffffff'
                                                      : filterOption.name === 'Black' || filterOption.name === 'Noir'
                                                      ? '#000000'
                                                      : filterOption.name === 'Tan' || filterOption.name === 'Beige'
                                                      ? '#ad9a84'
                                                      : filterOption.name === 'Natural' || filterOption.name === 'Naturel'
                                                      ? '#e8d3b5'
                                                      : handleize(filterOption.name);
                                                %>
                                                <div class="flex flex-col gap-2 justify-center items-center">
                                                  <div class=" flex  rounded-[5px] border border-gray-10 cursor-pointer  hover:swatch-selected hover:swatch-selected-filter <% if(filterOption.selected ==true) { %> swatch-selected swatch-selected-filter <% } %>" style="background-color: var(--color-<%=handleize(filterOption.name)%>); background-image: var(--image-<%=handleize(filterOption.name)%>); background-color: <%=color_bg%>; item_color_handle-color:<%=handleize(filterOption.name)%>; background-size: cover; background-position: center; width: 85px; height: 85px;"></div>
                                                  <span class="text-xs-medium text-center text-gray-60 truncate min-w-0 block" style="max-width: 80px;"><%=helper.translate(filterOption.name)%></span>
                                                </div>
                                              <% } else if (filter.key == "bed_style") { %>
                                                <div class="flex flex-col gap-2 justify-center items-center">
                                                  <div class=" flex  rounded-[5px] border border-gray-10 cursor-pointer  hover:swatch-selected hover:swatch-selected-filter <% if(filterOption.selected ==true) { %> swatch-selected swatch-selected-filter <% } %>" style="background-image: url(<%=filterOption.image%>); background-size: cover; background-position: center; width: 85px; height: 85px;"></div>
                                                  <span class="text-xs-medium text-center text-gray-60 truncate min-w-0 block" style="max-width: 80px;"><%=helper.translate(filterOption.label)%></span>
                                                </div>
                                              <% } else { %>
                                                <%=helper.translate(filterOption.name)%>
                                              <% } %>
                                            </span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                        </a>
                                    </li>

                                <%  }); %>
                            </ul>
                            <% if(filter.options.length > 5 ) { %>
                                <div class="kuShowOpt" tabindex="-1">
                                    <span class="kuFilterDot"></span><span class="kuFilterDot"></span><span class="kuFilterDot"></span>
                                </div>
                            <% } %>
                        </div>
                    </div>
                <% } else if(filter.type == "SLIDER")  { %>
                    <div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
                                <div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
                            </div>
                        </div>
                    </div>
                <% } else if (filter.type == "RATING")  { %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <%=helper.translate(filter.label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a
                                            target="_self"
                                            href="#"
                                            title="<%=helper.escapeHTML(filterOption.name)%>"
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>"
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kuFilterIcon"></span>
                                            <span class="kufacet-text">
                                                <div class="klevuFacetStars">
                                                    <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                                </div>
                                            </span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                        </a>
                                    </li>

                                <%  }); %>
                            </ul>
                        </div>
                    </div>
                <% } else { %>
                    <!-- Other Facets -->
                <% } %>
            <% }); %>

        </div>

        <div class="kuFiltersFooter">
            <button class="kuFiltersButton kuFiltersButton_reset kuFilterTagClearAll" tabindex="0"><span title="<%= helper.translate("Clear Filters") %>" class="kuFilterTagClearAll"><%= helper.translate("Clear") %></span></button>
            <button class="kuFiltersButton kuFiltersButton_apply" tabindex="0"><span class="text"><%= helper.translate("Apply")%></span></button>
        </div>
    </div>
<% } %>`;

var klevuLandingTemplateSortByCustom = `
<% if (data.query.productList.meta.totalResultsFound) {
var totalResultsFoundText = 'result';
if(data.query.productList.meta.totalResultsFound > 1){
    totalResultsFoundText = 'results';
}
} %>
<div class="sorting-info">

    <div class="kuDropdown kuDropSortBy" role="listbox">
        <div class="kuDropdownLabel">
            <%=helper.translate(helper.getSortBy(dataLocal))%>
        </div>
        <div class="kuDropdownOptions">
            <div class="kuDropOption kuSort" data-value="RELEVANCE" role="option"><%= helper.translate("Relevance") %></div>
            <div class="kuDropOption kuSort" data-value="PRICE_ASC" role="option"><%= helper.translate("Price, low to high") %></div>
            <div class="kuDropOption kuSort" data-value="PRICE_DESC" role="option"><%= helper.translate("Price, high to low") %></div>
        </div>
    </div>

    <div class="hidden md:flex flex-row p-1 border border-solid bg-gray-05 border-gray-20 rounded-[10px] mr-8" data-collection-switches="" data-component="styleCollection"  style="display: none !important;">
      <button class="bg-gray-05 border border-gray-05 hover:bg-gray-10 focus:bg-gray-05  focus:border-gray-05 focus-visible:bg-gray-05 focus-visible:border-2 focus-visible:border-gray-05 focus:outline-none focus-visible:outline-none disabled:bg-transparent disabled:text-gray-30 disabled:border-gray-30 backdrop-blur-lg h-12 py-3 px-5  rounded-lg flex justify-center items-center font-extrabold  text-gray-90 !border-gray-20 hover:!bg-gray-10 !bg-gray-10 text-base" data-collection-switch="product"><%= helper.translate("Product") %>
      </button>
      <button class="bg-gray-05 border border-gray-05 hover:bg-gray-10 focus:bg-gray-05  focus:border-gray-05 focus-visible:bg-gray-05 focus-visible:border-2 focus-visible:border-gray-05 focus:outline-none focus-visible:outline-none disabled:bg-transparent disabled:text-gray-30 disabled:border-gray-30 backdrop-blur-lg h-12 py-3 px-5  rounded-lg flex justify-center items-center font-extrabold  text-gray-70 text-base" data-collection-switch="lifestyle"><%= helper.translate("Lifestyle") %>
      </button>
    </div>
</div>`;

var klevuLandingTemplateBaseCustom = `
<div ku-container data-container-id="ku_landing_main_container" data-container-role="main">

    <header ku-container data-container-id="ku_landing_main_header_container" data-container-role="header">
        <section ku-block data-block-id="ku_landing_main_header_sub_panel"></section>
        <section ku-block data-block-id="ku_landing_main_header_banner">
            <%=helper.render('klevuLandingPromotionBanner',scope,data,"top") %>
            <%=helper.render('klevuLandingPromotionBanner',scope,data,"bottom") %>
        </section>
        <section ku-block data-block-id="ku_landing_main_header_site_navigation"></section>
    </header>

    <div class="kuContainer">
        <% if(false) { %>
            <%=helper.render('noResultsFoundLanding',scope) %>
        <% } else { %>
            <%= helper.render('klevuLandingTemplateSearchBar', scope) %>
            <%=helper.render('klevuLandingImageSearchUploadBanner',scope,data) %>
            <%= helper.render('tab-results', scope) %>
            <%= helper.render('results',scope) %>
        <% } %>
        <div class="kuClearBoth"></div>
    </div>

    <footer ku-container data-container-id="ku_landing_main_footer_container" data-container-role="footer">
        <section ku-block data-block-id="ku_landing_main_footer_sub_panel"></section>
        <section ku-block data-block-id="ku_landing_main_footer_banner">

        </section>
    </footer>

</div>`;

var klevuLandingTemplateResultsHeadingTitleCustom = `
<%
    var totalProductResultsFound = klevu.getObjectPath(data,"query.productList.meta.totalResultsFound", 0);
    var totalContentResultsFound = klevu.getObjectPath(data,"query.contentList.meta.totalResultsFound", 0);
    var totalNumberOfResults = totalProductResultsFound + totalContentResultsFound;
    var resultText = totalNumberOfResults === 1 ? 'Result' : 'Results';
    var searchedTerm = helper.escapeHTML(data.settings.term);
    var isCATNAV = data.settings.isCATNAV;
    if(isCATNAV){
        searchedTerm = helper.escapeHTML(data.settings.categoryPath);
    }
%>
<div class="kuResultsHeadingTitleContainer">
    <strong class="kuResultsNumber"> <%= totalNumberOfResults %> </strong> <%= helper.translate(resultText) %> <%=helper.translate("found")%> <%= (searchedTerm && searchedTerm.length && searchedTerm != "*") ? helper.translate("for") + " '<span>"+ klevu.dom.helpers.cleanCatogeryPath(searchedTerm) +"</span>'" : "" %>
</div>`;
